var sliderThumbnail = new Swiper('.gallery-thumbs', {
  slidesPerView: 4,
  spaceBetween: 10,
  freeMode: true,
  watchSlidesProgress: true,
  // ❌ NO LOOP HERE
});

var slider = new Swiper('.gallery-slider', {
  slidesPerView: 1,
  loop: true, // ✅ ONLY HERE
  loopedSlides: 6,

  navigation: {
    nextEl: '#nextButton',
    prevEl: '#prevButton',
  },

  thumbs: {
    swiper: sliderThumbnail
  }
});